export default __webpack_public_path__ + "static/media/admin-gestao-paginas-on.7a1e5e10.svg";